import { DataService } from './dataService'

const HsCodeRemarkService = {
	getHscoderemarks: async(data) => {
		return DataService.get('/admin/hscode_remarks', data)
	},
	addHscoderemarks: async (data) => {
		return DataService.post('/admin/hscode_remarks', data)
	},
	updateHscoderemark: async (data) => {
        return DataService.put('/admin/hscode_remarks', data)
    },
	deleteHscoderemark: async (data) => {
        return DataService.delete('/admin/hscode_remarks', data)
    },    
}

export default HsCodeRemarkService